import React from 'react'
import SettingApiForm from '../components/setting/settingOneSignalForm'

const SettingOneSignal = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingOneSignal